import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'
import { Link } from 'react-router-dom'

import Actions from './Actions'
import Paragraph from '@components/Details/Paragraph'
import Row from '@components/Details/Row'

class Details extends Component {
  static propTypes = {
    accountStore: PropTypes.object,
    atheneumOfficeStore: PropTypes.object,
    sidebarStore: PropTypes.object
  }

  render () {
    const { accountStore, atheneumOfficeStore, sidebarStore } = this.props
    const {
      account,
      parentAccount,
      invoicingEntities,
      contracts
    } = accountStore
    const { atheneumOffices } = atheneumOfficeStore

    const keyContact = account.keyContact

    const atheneumOffice = atheneumOffices.find(
      office => office.id === account.atheneumOfficeId
    )

    return (
      <DocumentTitle
        title={`${account.companyName} - details | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <Actions
            accountStore={accountStore}
            account={account}
            parentAccount={parentAccount}
            invoicingEntities={invoicingEntities}
          />
          <div className='content'>
            <div className='col-2'>
              <Paragraph
                title='Account specific operational Guidelines'
                value={account.operationalGuidelines}
              />
              <Paragraph
                title='Parent account operational Guidelines'
                value={parentAccount.operationalGuidelines}
              />
              <Paragraph
                title='External Compliance Verification'
                value={
                  account.externalComplianceRequired
                    ? 'Required'
                    : 'Not required'
                }
              />
            </div>
            <div className='col-2 col-2--padding'>
              <div className='story'>
                <span className='label'>Account details</span>
                <div className='group-wrapper'>
                  <div className='group'>
                    <Row label='Atheneum company' text={atheneumOffice.name} />
                    <Row
                      label='Key Atheneum contact'
                      text={keyContact && keyContact.fullName}
                    />
                  </div>
                </div>
                <span className='label'>
                  Account specific invoicing entities
                </span>
                <div className='group-wrapper'>
                  <div className='group'>
                    {invoicingEntities.length > 0
                      ? invoicingEntities.map(invoicingEntity => (
                          <Row
                            noLabel
                            key={invoicingEntity.id}
                            text={invoicingEntity.legalName}
                            onClick={() =>
                              sidebarStore.openSidebar({
                                id: invoicingEntity.id,
                                template: 'invoicing-entity'
                              })
                            }
                          />
                        ))
                      : '-'}
                  </div>
                </div>
                <span className='label'>Applicable contracts</span>
                <div className='group-wrapper'>
                  <div className='group'>
                    {contracts.length > 0
                      ? contracts.map(contract => (
                          <div key={contract.id}>
                            <Link
                              className='row--link'
                              to={'/contract/' + contract.id}
                            >
                              {contract.contractReference}
                            </Link>
                          </div>
                        ))
                      : '-'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('atheneumOfficeStore', 'sidebarStore')(observer(Details))
